import { render, staticRenderFns } from "./LogisticPresidentDashboard.vue?vue&type=template&id=7afb6a84&scoped=true&"
import script from "./LogisticPresidentDashboard.vue?vue&type=script&lang=js&"
export * from "./LogisticPresidentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LogisticPresidentDashboard.vue?vue&type=style&index=0&id=7afb6a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afb6a84",
  null
  
)

export default component.exports